import styled, { keyframes } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const pulsate = keyframes`
    0% {transform: scale(0.1, 0.1); opacity: 0.0;}
    50% {opacity: 1.0;}
    100% {transform: scale(1.2, 1.2); opacity: 0.0;}
`;

export const PulseDotWrapper = styled(Flex)<{ $size: number }>`
    position: relative;
    height: ${({ $size }) => `${$size}px`};
    width: ${({ $size }) => `${$size}px`};
    justify-content: center;
    align-items: center;
`;

export const PulseDotRing = styled.div<{ $color: string; $pulseDiameter: number; $pulseBg: string }>`
    background-color: ${({ $pulseBg }) => $pulseBg};
    border: 3px solid ${({ $color }) => $color};
    border-radius: ${({ $pulseDiameter }) => `${$pulseDiameter}px`};
    height: ${({ $pulseDiameter }) => `${$pulseDiameter}px`};
    width: ${({ $pulseDiameter }) => `${$pulseDiameter}px`};
    position: absolute;
    animation: ${pulsate} 1s ease-out;
    animation-iteration-count: infinite;
    opacity: 0;
`;

export const PulseDotCenter = styled.div<{ $color: string; $centerDiameter: number }>`
    width: ${({ $centerDiameter }) => `${$centerDiameter}px`};
    height: ${({ $centerDiameter }) => `${$centerDiameter}px`};
    background-color: ${({ $color }) => $color};
    border-radius: 50%;
    position: absolute;
`;

interface IPulseDotProps {
    color?: string;
    pulseBg?: string;
    pulseDiameter?: number;
    centerDiameter?: number;
    padding?: number;
}

export const PulseDot = ({
    color = colorsPalettes.red[500],
    pulseBg = colorsPalettes.red[100],
    pulseDiameter = 24,
    centerDiameter = 8,
    padding = 4,
}: IPulseDotProps) => {
    return (
        <PulseDotWrapper $size={pulseDiameter + centerDiameter + padding * 2}>
            <PulseDotRing
                $color={color}
                $pulseBg={pulseBg}
                $pulseDiameter={pulseDiameter}
            />
            <PulseDotCenter
                $color={color}
                $centerDiameter={centerDiameter}
            />
        </PulseDotWrapper>
    );
};
